// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;

function IconButton(props) {
  let __className = props.className;
  let __disabled_ = props.disabled;
  let onPress = props.onPress;
  let disabled_ = __disabled_ !== undefined ? __disabled_ : false;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
    onClick: param => onPress(),
    disabled: disabled_,
    className: TailwindMerge.twMerge([
      "border border-zinc-300 rounded-[20px] cursor-pointer p-1.5 text-zinc-400 disabled:border-zinc-200 disabled:bg-zinc-50 disabled:text-zinc-300 hover:bg-zinc-100 hover:text-zinc-500",
      className
    ]),
    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(VisuallyHidden, {
          children: props.title
        }),
        JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: props.icon
          }),
          "aria-hidden": true,
          className: "flex"
        })
      ]
    })
  });
}

let make = IconButton;

exports.make = make;
/* IconV5 Not a pure module */
